import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareTimesIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 9 10' {...props}>
    <path
      d='M0 7.84299L2.84595 4.99098L0.0269775 2.16499L1.427 0.755981L4.24695 3.58199L7.05896 0.763985L8.45898 2.17298L5.64795 4.98998L8.48499 7.83398L7.08496 9.24298L4.24695 6.39899L1.401 9.25098L0 7.84299Z'
      fill='currentColor'
    />
  </SvgWrapper>
);
export const TimesIcon = memo(BareTimesIcon);
